<template >
  <div class="bg-sub2">
    <div class="header-page container">
      <h4 class="header-history">ข่าวทั้งหมด</h4>
      <div class="recommended-content">
        <section class="cards">
          <div class="card-recommended" v-for="item in pageOfItems" :key="item.id">
            <div class="" @click="ReadNews(item.url)">
              <div class="preview-video">
                <figure class="sixteen-nine-img-news">
                  <img :src="item.thumb" />
                </figure>
              </div>
              <div class="card-content-news">
                <h4 class="card-title">{{ item.name }}</h4>
                <p class="card-desc">{{ item.desc }}</p>
              </div>
            </div>
          </div>
        </section>
        <jw-pagination :items="news" :pageSize="20" @changePage="onChangePage"></jw-pagination>
      </div>

      <!-- Modal share -->
      <modal centered v-if="modalShare" @close="modalShare = false">
        <!--fa class="close-modal" color="danger" icon="close"@click.native="modalShare = false" /-->
        <modal-header>
          <modal-title>แชร์ลิ้งค์</modal-title>
        </modal-header>
        <modal-body>
          <div class="padding-share">
            <!--div class="text-center input-share">
            <input type="text" class="form-control shareLink" name="" value="" v-model="Link" disabled>
          </div-->
            <div class="input-link input-share">
              <input type="text" v-model="Link" id="linkURL" class="form-control shareLink" readonly="readonly">
              <btn color="primary" class="btn-chat" @click="CopyLink()"><span>คัดลอก</span></btn>
            </div>
          </div>

        </modal-body>
      </modal>
      <!-- /Modal share -->
    </div>
  </div>
</template>

<script>
import config from '../config';
import axios from 'axios';
const Host = config.app.Host;
import {
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  Btn,
  Fa,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter
} from 'mdbvue';

export default {
  name: 'NewsPage',
  components: {
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    Btn,
    Fa,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter
  },
  data() {
    return {
      Link: '',
      modalShare: false,
      news: [],
      pageOfItems: []
    };
  },
  mounted() {
    this.NewsFeed();
    // this.ToggleLogin();
    localStorage.pincode = '';
    this.Session();
  },
  methods: {
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    Session() {
      let APIgetSession = Host + '/api/v1/member/session';
      axios.post(APIgetSession, {
        token: localStorage.token
      }).then(response => {
        if (response.data.code !== '200') {
          localStorage.emailfront = '';
          localStorage.token = '';
          localStorage.auth = 'false';
        }
      });
    },
    ToggleLogin() {
      if (localStorage.auth == 'false' || !localStorage.auth) {
        this.$router.push('/');
      }
      this.modalLogin = true;
    },
    ShareLink(data) {
      this.Link = data.share;
    },
    NewsFeed() {
      let APIgetNewsFeed = Host + '/api/v1/news/more';
      axios.get(APIgetNewsFeed).then(response => {
        this.news = response.data.result;
      });
    },
    ReadNews(url) {
      window.open(url);
    }
  }
};
</script>

<style lang="css"></style>
